import { render, staticRenderFns } from "./BjglList.vue?vue&type=template&id=170e3d8c&scoped=true"
import script from "./BjglList.vue?vue&type=script&lang=js"
export * from "./BjglList.vue?vue&type=script&lang=js"
import style0 from "./BjglList.vue?vue&type=style&index=0&id=170e3d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e3d8c",
  null
  
)

export default component.exports